
<app-navbar></app-navbar>
<div style="margin-top: 100px;">
  <router-outlet></router-outlet> 
</div>

